import { withI18n } from 'react-i18next';
import EmailClaimsModal from './EmailClaimsModal';

export default withI18n()(EmailClaimsModal);

// export default withI18n(mapStateToProps)(EmailClaimsModal);
